/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 15:14:01
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const REVERT_THEME_REQUEST = 'REVERT_THEME_REQUEST';
type REVERT_THEME_REQUEST_TYPE = 'REVERT_THEME_REQUEST';

export const REVERT_THEME_SUCCESS = 'REVERT_THEME_SUCCESS';
type REVERT_THEME_SUCCESS_TYPE = 'REVERT_THEME_SUCCESS';

export const REVERT_THEME_FAILURE = 'REVERT_THEME_FAILURE';
type REVERT_THEME_FAILURE_TYPE = 'REVERT_THEME_FAILURE';

export const REVERT_THEME_FEEDBACK_REQUEST = 'REVERT_THEME_FEEDBACK_REQUEST';
type REVERT_THEME_FEEDBACK_REQUEST_TYPE = 'REVERT_THEME_FEEDBACK_REQUEST';

export const REVERT_THEME_FEEDBACK_SUCCESS = 'REVERT_THEME_FEEDBACK_SUCCESS';
type REVERT_THEME_FEEDBACK_SUCCESS_TYPE = 'REVERT_THEME_FEEDBACK_SUCCESS';

export const REVERT_THEME_FEEDBACK_FAILURE = 'REVERT_THEME_FEEDBACK_FAILURE';
type REVERT_THEME_FEEDBACK_FAILURE_TYPE = 'REVERT_THEME_FEEDBACK_FAILURE';

export const REVERT_THEME_MANUAL_CONTACT_REQUEST = 'REVERT_THEME_MANUAL_CONTACT_REQUEST';
type REVERT_THEME_MANUAL_CONTACT_REQUEST_TYPE = 'REVERT_THEME_MANUAL_CONTACT_REQUEST';

export const REVERT_THEME_MANUAL_CONTACT_SUCCESS = 'REVERT_THEME_MANUAL_CONTACT_SUCCESS';
type REVERT_THEME_MANUAL_CONTACT_SUCCESS_TYPE = 'REVERT_THEME_MANUAL_CONTACT_SUCCESS';

export const REVERT_THEME_MANUAL_CONTACT_FAILURE = 'REVERT_THEME_MANUAL_CONTACT_FAILURE';
type REVERT_THEME_MANUAL_CONTACT_FAILURE_TYPE = 'REVERT_THEME_MANUAL_CONTACT_FAILURE';

export const RESET_THEME_REVERT = 'RESET_THEME_REVERT';
type RESET_THEME_REVERT_TYPE = 'RESET_THEME_REVERT';

type ThemeRevertFailure = {
  error: any
};

type RevertThemeRequestAction = Action<REVERT_THEME_REQUEST_TYPE, null>;

type RevertThemeSuccessAction = Action<REVERT_THEME_SUCCESS_TYPE, { data: { message: string } }>;

type RevertThemeFailureAction = Action<REVERT_THEME_FAILURE_TYPE, ThemeRevertFailure>;

type RevertThemeFeedbackRequestAction = Action<REVERT_THEME_FEEDBACK_REQUEST_TYPE, null>;

type RevertThemeFeedbackSuccessAction = Action<
  REVERT_THEME_FEEDBACK_SUCCESS_TYPE,
  { data: { message: string } }
>;

type RevertThemeFeedbackFailureAction = Action<
  REVERT_THEME_FEEDBACK_FAILURE_TYPE,
  ThemeRevertFailure
>;

type RevertThemeManualContactRequestAction = Action<REVERT_THEME_MANUAL_CONTACT_REQUEST_TYPE, null>;

type RevertThemeManualContactSuccessAction = Action<
  REVERT_THEME_MANUAL_CONTACT_SUCCESS_TYPE,
  { data: { message: string } }
>;

type RevertThemeManualContactFailureAction = Action<
  REVERT_THEME_MANUAL_CONTACT_FAILURE_TYPE,
  ThemeRevertFailure
>;

type ResetThemeRevert = Action<RESET_THEME_REVERT_TYPE, null>;

export type ThemeRevertAction =
  | RevertThemeRequestAction
  | RevertThemeSuccessAction
  | RevertThemeFailureAction
  | RevertThemeFeedbackRequestAction
  | RevertThemeFeedbackSuccessAction
  | RevertThemeFeedbackFailureAction
  | RevertThemeManualContactRequestAction
  | RevertThemeManualContactSuccessAction
  | RevertThemeManualContactFailureAction
  | ResetThemeRevert;

export type ThemeRevertState = {
  loading: boolean,
  success: boolean,
  feedbackLoading: boolean,
  feedbackSuccess: boolean,
  revertThemeError: boolean,
  error: any
};
